import { useStaticQuery, graphql } from 'gatsby'

export default function useGetAllFile() {
    const data = useStaticQuery(graphql`
        query allFileQuery {
            allFile {
                edges {
                    node {
                        relativePath
                        publicURL
                    }
                }
            }
        }
    `)
    return data.allFile.edges
}
